export default __webpack_public_path__ + "static/GT-America-Condensed-Black-Italic-5adc8e53c980bf439bc3e37554ee7dd1.ttf";